module.exports = new __parcel__URL__("snare_11.64dc3f03.mp3").toString();